import { io } from 'socket.io-client';

class SocketClient {
  constructor() {
    this.socket = io(process.env.VUE_APP_SOCKET_URL, {
      withCredentials: true,
    });

    this.socket.connect();
  }

  disconnect() {
    return this.socket.disconnect();
  }

  informAvailability(data) {
    return this.socket.emit('update-pax', data);
  }

  watchUpdatePax(callback) {
    return this.socket.on('update-pax', callback);
  }

  watchMonitor() {
    return this.socket.emit('watch-monitor');
  }

  unwatchMonitor() {
    return this.socket.emit('unwatch-monitor');
  }

  watchStopSales(callback) {
    return this.socket.on('stop-sales', callback);
  }

  watchDelay(callback) {
    return this.socket.on('inform-delay', callback);
  }

  watchDriver(driver) {
    return this.socket.emit('watch-driver', driver);
  }

  watchDriverPosition(callback) {
    return this.socket.on('signal-driver-position', callback);
  }

  watchPickupChange(callback) {
    return this.socket.on('pickup-change', callback);
  }
}

export default new SocketClient();
